export default {
  CUSTOMER_OVERVIEW_STATE_MANAGER: Symbol.for('CUSTOMER_OVERVIEW_STATE_MANAGER'),
  CUSTOMER_OVERVIEW_REPOSITORY: Symbol.for('CUSTOMER_OVERVIEW_REPOSITORY'),
  GET_CUSTOMER_OVERVIEW_QUERY: Symbol.for('GET_CUSTOMER_OVERVIEW_QUERY'),
  CUSTOMER_OVERVIEW_SERVICE: Symbol.for('CUSTOMER_OVERVIEW_SERVICE'),
};
